import {
  Button,
  Col,
  Form,
  InputNumber,
  Modal,
  Row,
  Space,
  Typography,
} from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../context";

const DialogCashFunds = ({ open, close, rerun }) => {
  const [oneThousandBill, setoneThousandBill] = useState(0);
  const [fiveHundredBill, setfiveHundredBill] = useState(0);
  const [twoHundredBill, settwoHundredBill] = useState(0);
  const [oneHundredBill, setoneHundredBill] = useState(0);
  const [fiftyBill, setfiftyBill] = useState(0);
  const [twentyBill, settwentyBill] = useState(0);
  const [twentyCoin, settwentyCoin] = useState(0);
  const [tenCoin, settenCoin] = useState(0);
  const [fiveCoin, setfiveCoin] = useState(0);
  const [oneCoin, setoneCoin] = useState(0);
  const [fiftyCentsCoin, setfiftyCentsCoin] = useState(0);
  const [twentyfiveCentsCoin, settwentyfiveCentsCoin] = useState(0);
  const [tenCentsCoin, settenCentsCoin] = useState(0);
  const [fiveCentsCoin, setfiveCentsCoin] = useState(0);
  const [oneCentCoin, setoneCentCoin] = useState(0);
  const { userData } = useContext(UserInfo);
  const { rerunNotif } = useContext(NotificationInfo);

  const handleCreateADailyCashFund = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append(
      "merchant_user_id",
      userData.data.usersmerchantemployee.merchant_user_id
    );
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    // formdata.append("cf_bill_1000", oneThousandBill);
    // formdata.append("cf_bill_500", fiveHundredBill);
    // formdata.append("cf_bill_200", twoHundredBill);
    // formdata.append("cf_bill_100", oneHundredBill);
    // formdata.append("cf_bill_50", fiftyBill);
    // formdata.append("cf_bill_20", twentyBill);
    // formdata.append("cf_coin_20", twentyCoin);
    // formdata.append("cf_coin_10", tenCoin);
    // formdata.append("cf_coin_5", fiveCoin);
    // formdata.append("cf_coin_1", oneCoin);
    // formdata.append("cf_coin_50c", fiftyCentsCoin);
    // formdata.append("cf_coin_25c", twentyfiveCentsCoin);
    // formdata.append("cf_coin_10c", tenCentsCoin);
    // formdata.append("cf_coin_5c", fiveCentsCoin);
    // formdata.append("cf_coin_1c", oneCentCoin);

    formdata.append(
      "cf_total",
      parseFloat(oneThousandBill) +
        parseFloat(fiveHundredBill) +
        parseFloat(twoHundredBill) +
        parseFloat(oneHundredBill) +
        parseFloat(fiftyBill) +
        parseFloat(twentyBill) +
        parseFloat(twentyCoin) +
        parseFloat(tenCoin) +
        parseFloat(fiveCoin) +
        parseFloat(oneCoin) +
        parseFloat(fiftyCentsCoin) +
        parseFloat(twentyfiveCentsCoin) +
        parseFloat(tenCentsCoin) +
        parseFloat(fiveCentsCoin) +
        parseFloat(oneCentCoin)
    );

    axios
      .post("user/merchant-employee/create/cash-count-daily", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Created cash fund successfully.");
          setTimeout(() => {
            close();
            rerun();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };

  return (
    <Modal
      title=""
      open={open}
      //   onCancel={() => close()}
      closable={false}
      footer={null}
      width={350}
      centered
    >
      <Form
        layout="vertical"
        name="add-cash-fund"
        onFinish={handleCreateADailyCashFund}
        autoComplete="off"
      >
        <Space
          direction="vertical"
          style={{ width: "100%", margin: 0, marginTop: 20 }}
        >
          <Row>
            <Col
              xs={24}
              style={{ borderBottom: "1px solid #e5e5e5", marginBottom: 10 }}
            >
              <Typography style={{ fontWeight: "bold", fontSize: 18 }}>
                PESO BILL
              </Typography>
            </Col>
            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="cf_bill_1000"
                  label="1000 Bill"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => setoneThousandBill(value * 1000)}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="cf_bill_500"
                  label="500 Bill"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => setfiveHundredBill(value * 500)}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="cf_bill_200"
                  label="200 Bill"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => settwoHundredBill(value * 200)}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="cf_bill_100"
                  label="100 Bill"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => setoneHundredBill(value * 100)}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="cf_bill_50"
                  label="50 Bill"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => setfiftyBill(value * 50)}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="cf_bill_20"
                  label="20 Bill"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => settwentyBill(value * 20)}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col
              xs={24}
              style={{ borderBottom: "1px solid #e5e5e5", marginBottom: 10 }}
            >
              <Typography style={{ fontWeight: "bold", fontSize: 18 }}>
                PESO COIN
              </Typography>
            </Col>
            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="cf_coin_20"
                  label="20 Coin"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => settwentyCoin(value * 20)}
                  />
                </Form.Item>
              </div>
            </Col>

            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="cf_coin_10"
                  label="10 Coin"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => settenCoin(value * 10)}
                  />
                </Form.Item>
              </div>
            </Col>

            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="cf_coin_5"
                  label="5 Coin"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => setfiveCoin(value * 5)}
                  />
                </Form.Item>
              </div>
            </Col>

            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="cf_coin_1"
                  label="1 Coin"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => setoneCoin(value * 1)}
                  />
                </Form.Item>
              </div>
            </Col>

            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="cf_coin_50c"
                  label="50 Cents"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => setfiftyCentsCoin(value * 0.5)}
                  />
                </Form.Item>
              </div>
            </Col>

            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="cf_coin_25c"
                  label="25 Cents"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => settwentyfiveCentsCoin(value * 0.25)}
                  />
                </Form.Item>
              </div>
            </Col>

            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="cf_coin_10c"
                  label="10 Cents"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => settenCentsCoin(value * 0.1)}
                  />
                </Form.Item>
              </div>
            </Col>

            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="cf_coin_5c"
                  label="5 Cents"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => setfiveCentsCoin(value * 0.05)}
                  />
                </Form.Item>
              </div>
            </Col>

            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="cf_coin_1c"
                  label="1 Cent Coin"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => setoneCentCoin(value * 0.01)}
                  />
                </Form.Item>
              </div>
            </Col>
          </Row>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              border: "1px solid green",
            }}
          >
            <Typography style={{ fontSize: 22, fontWeight: "bold" }}>
              &#8369;
              {parseFloat(
                parseFloat(oneThousandBill) +
                  parseFloat(fiveHundredBill) +
                  parseFloat(twoHundredBill) +
                  parseFloat(oneHundredBill) +
                  parseFloat(fiftyBill) +
                  parseFloat(twentyBill) +
                  parseFloat(twentyCoin) +
                  parseFloat(tenCoin) +
                  parseFloat(fiveCoin) +
                  parseFloat(oneCoin) +
                  parseFloat(fiftyCentsCoin) +
                  parseFloat(twentyfiveCentsCoin) +
                  parseFloat(tenCentsCoin) +
                  parseFloat(fiveCentsCoin) +
                  parseFloat(oneCentCoin)
              ).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </Typography>
            <Typography style={{ color: "green", fontWeight: "bold" }}>
              Total
            </Typography>
          </div>
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            Set & Confirm Cash Fund
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default DialogCashFunds;
